import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import PropertyField from "@features/builder/NodeDrawer/NodeForm/PropertyField"
import NodeDrawerAccordion from "@features/builder/NodeDrawer/NodeDrawerAccordion"
import { Grid } from "@mui/material"
import { useFormContext } from "react-hook-form"

const SampleValueAccordion = () => {
  const form = useFormContext<NodeFormValues>()

  return (
    <NodeDrawerAccordion id="sample-value" label="Sample value">
      <Grid item>
        <PropertyField
          control={form.control}
          type="number"
          label="Sample value"
          name="sample_value"
        />
      </Grid>
    </NodeDrawerAccordion>
  )
}

export default SampleValueAccordion
